import _ from "lodash";
import { matchPath, useLocation } from "react-router-dom-v5-compat";
import { AdjustmentApplication, AdjustmentType, AdjustmentValidation } from "../../../MealTrack/MTAPITypes";
import { AccountRoutesType } from "../Navigation/navigationUtils";
import { CartSelectionModeType, useCartSettings } from "./OrderSummary.request";
import { getOrderSummaryLocation } from "../../../OrderFlow/components/Cart/emptyCart-helpers";
export const useOrderSummary = (order, cartSettings, allowEditing, balance) => {
    var _a, _b;
    const location = useLocation();
    const isOrderFlow = !!matchPath({ path: "/:sku/OrderFlow" }, location.pathname);
    const isCheckout = !!matchPath({ path: "/:sku/Checkout" }, location.pathname);
    const isMyMeals = location.pathname === AccountRoutesType.MY_MEALS;
    const orderSummaryLocation = getOrderSummaryLocation(isOrderFlow, isCheckout, isMyMeals);
    const { loading, settings } = useCartSettings(order.sku, cartSettings);
    let perMealDiscount = 0;
    const perMealCoupon = balance === null || balance === void 0 ? void 0 : balance.cost.order.adjustments.find((c) => c.application === AdjustmentApplication.PerMeal &&
        !(c.adjustmentType === AdjustmentType.Surcharge) &&
        c.validation === AdjustmentValidation.Valid);
    const perMealCouponDiscountAppliedValue = perMealCoupon ? perMealCoupon.appliedValue : 0;
    const subtotalMinusPerMealCoupon = order.subtotal - perMealCouponDiscountAppliedValue;
    const subscriptionMealsGroupedByDay = _.flatten(Object.values(_.groupBy((_a = order.subscriptions) === null || _a === void 0 ? void 0 : _a.meals, "day")));
    const subscriptionProductsGroupedByDay = _.groupBy((_b = order.subscriptions) === null || _b === void 0 ? void 0 : _b.products, "dayOfWeek");
    if (balance === null || balance === void 0 ? void 0 : balance.cost.order.adjustments) {
        perMealDiscount = balance.cost.order.adjustments
            .filter((c) => c.application === AdjustmentApplication.PerMeal &&
            !(c.adjustmentType === AdjustmentType.Surcharge) &&
            c.validation === AdjustmentValidation.Valid)
            .reduce((acc, c) => acc + c.adjustmentValue, 0);
    }
    const canEditCart = (settings === null || settings === void 0 ? void 0 : settings.cartSelectionMode) !== CartSelectionModeType.NONE && allowEditing;
    const canAddRemoveMeals = (settings === null || settings === void 0 ? void 0 : settings.cartSelectionMode) === CartSelectionModeType.CAN_ADD_REMOVE_MEALS;
    const canAddRemoveRecipes = (settings === null || settings === void 0 ? void 0 : settings.cartSelectionMode) === CartSelectionModeType.CAN_ADD_REMOVE_RECIPES;
    // Only filter meals with 0 quantity when not in edit mode.
    if (!canEditCart) {
        order.dates.forEach((date) => {
            date.meals = date.meals.filter((meal) => meal.quantity > 0);
        });
        order.dates = order.dates.filter((date) => { var _a; return date.meals.length > 0 || (date.products && ((_a = date.products) === null || _a === void 0 ? void 0 : _a.length) > 0); });
    }
    return {
        canAddRemoveMeals,
        canAddRemoveRecipes,
        canEditCart,
        loading,
        perMealCouponDiscountAppliedValue,
        perMealDiscount,
        settings,
        subscriptionMealsGroupedByDay,
        subscriptionProductsGroupedByDay,
        subtotalMinusPerMealCoupon,
        orderSummaryLocation,
    };
};
